import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import JourneyNudge from "@/components/JourneyNudge";

const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order") || "";

  return (
    <main data-testid="payment-success-page" className="pt-20">
      <section className="py-24 md:py-32">
        <div className="max-w-lg mx-auto px-6 text-center">
          <div
            className="w-20 h-20 rounded-full mx-auto flex items-center justify-center mb-8"
            style={{ background: "var(--ll-green)" }}
          >
            <CheckCircle size={40} style={{ color: "var(--ll-text)" }} />
          </div>

          <h1
            className="font-serif text-3xl sm:text-4xl font-light mb-4"
            style={{ color: "var(--ll-text)" }}
          >
            Payment Successful
          </h1>
          <p
            className="text-base leading-relaxed mb-4"
            style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}
          >
            Thank you for your purchase! Your order is being processed and you'll receive a confirmation email shortly.
          </p>
          {orderId && (
            <p
              className="text-xs mb-8 p-3 rounded-xl inline-block"
              style={{ background: "var(--ll-bg-secondary)", color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}
            >
              Order Reference: {orderId}
            </p>
          )}
          <div className="mb-12 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              data-testid="success-back-home"
              className="inline-flex rounded-full px-8 py-3.5 text-sm font-medium transition-all duration-300 hover:-translate-y-0.5"
              style={{
                background: "var(--ll-cta)",
                color: "var(--ll-cta-text)",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              Back to Home
            </Link>
            <Link
              to="/course"
              data-testid="success-access-course"
              className="inline-flex rounded-full px-8 py-3.5 text-sm font-medium border transition-all duration-300 hover:-translate-y-0.5"
              style={{
                borderColor: "var(--ll-border)",
                color: "var(--ll-text-secondary)",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              Access Course
            </Link>
            <Link
              to="/kit/kit-self-care"
              data-testid="success-access-kits"
              className="inline-flex rounded-full px-8 py-3.5 text-sm font-medium border transition-all duration-300 hover:-translate-y-0.5"
              style={{
                borderColor: "var(--ll-border)",
                color: "var(--ll-text-secondary)",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              Access My Kits
            </Link>
          </div>
        </div>

        {/* Journey nudge */}
        <div className="max-w-2xl mx-auto px-6">
          <JourneyNudge context="after_purchase" />
        </div>
      </section>
    </main>
  );
};

export default PaymentSuccessPage;
